<template>
    <div class="overview-panel">
        <div class="row" v-if="isAuth('D11')">
            <div class="ah-container">
                <div class="ah-panel padding main-bg-color" style="padding: 25px">
                    <el-row :gutter="20">
                        <el-col :sm="14">
                            <div class="main-color-loading" v-loading="isLoading" element-loading-background="rgba(70, 60, 178, 0.5)" element-loading-text="載入中">
                                <div style="margin-bottom: 10px">
                                    <el-radio-group class="overiew-radio-group" v-model="mode" size="mini">
                                        <el-radio-button :label="0" border> 單月 </el-radio-button>
                                        <el-radio-button :label="1"> 累計 </el-radio-button>
                                    </el-radio-group>
                                </div>
                                <YearOverviewChart :monthlyData="monthlyRevenueDatas" :mode="mode" />
                            </div>
                        </el-col>
                        <el-col :sm="10">
                            <div v-if="isShowRealTime" class="realtime-label">即時：{{ currentDate }}</div>
                            <div class="ah-card main-color" style="margin-top: 10px">
                                <div class="content">
                                    <div class="statis-title">
                                        營業淨收<ah-tip>營業總收入-營業總支出</ah-tip>
                                        <span class="percentage">{{ profitPercentage }} %</span>
                                    </div>
                                    <div class="statis-num">
                                        <Money :v="revenueInfo.netIncome" round />
                                        <span class="cny">TWD</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="5">
                            <div
                                class="ah-card main-color"
                                @mouseover="isHighlightIncomes = true"
                                @mouseleave="isHighlightIncomes = false"
                                @focus="isHighlightIncomes = true"
                                @blur="isHighlightIncomes = false"
                            >
                                <div class="content">
                                    <div class="statis-title">
                                        營業總收入<ah-tip>營業收入 ＋ 財務管理-其他收入</ah-tip>
                                        <span class="percentage">100 %</span>
                                    </div>
                                    <div class="statis-num">
                                        <Money :v="revenueInfo.income" round />
                                        <span class="cny">TWD</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="5">
                            <div
                                class="ah-card main-color"
                                @mouseover="isHighlightPayouts = true"
                                @mouseleave="isHighlightPayouts = false"
                                @focus="isHighlightPayouts = true"
                                @blur="isHighlightPayouts = false"
                            >
                                <div class="content">
                                    <div class="statis-title">
                                        營業總支出<ah-tip
                                            >請款單 <PaymentStatusLabel :statusNum="2" />＋
                                            <PaymentStatusLabel :statusNum="3" />
                                            總額 + 人事薪資 ＋ 營業其他支出
                                        </ah-tip>
                                        <span class="percentage">{{ payoutPercentage }} %</span>
                                    </div>
                                    <div class="statis-num">
                                        <Money :v="revenueInfo.payout" round />
                                        <span class="cny">TWD</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <slot name="middle"></slot>
        <div style="margin-top: 25px" v-if="isAuth('D11')" class="four-statistics">
            <div class="ah-container income-payout-status">
                <el-row :gutter="20">
                    <el-col :sm="12" :md="6">
                        <div class="ah-card shadow invoice-status">
                            <div class="content">
                                <div :class="{
                                    total: true,
                                }">
                                    <div class="statis-title main-color">
                                        <span>發票收款</span>
                                        <ah-tip>
                                            <InvoiceStatusLabel :statusNum="3" />
                                            ＋
                                            <InvoiceStatusLabel :statusNum="2" />
                                            發票總額 (含稅)
                                        </ah-tip>
                                        <div class="sub-section-title">收款情形</div>
                                    </div>
                                    <div class="statis-num">
                                        <Money :v="receivableInfo.accountsReceived" round />
                                    </div>
                                </div>
                                <div class="statis-detail">
                                    <ul class="value-list">
                                        <li :class="{ item: true }">
                                            <span class="label">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <InvoiceStatusLabel :statusNum="3" />
                                                </div>
                                            </span>
                                            <span class="value">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <Money :v="receivableInfo.accountsReceivable" round />
                                                    <span class="side-percentage"> {{ invoiceCompletePercentage }}% </span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <InvoiceStatusLabel :statusNum="2" />
                                                </div>
                                            </span>
                                            <span class="value">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <Money :v="receivableInfo.accruedReceivables" round />
                                                    <span class="side-percentage"> {{ invoicePendingPercentage }}% </span>
                                                </div>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="statis-detail compact" style="margin-top: 18px">
                                    <ul class="value-list">
                                        <li class="item" :class="{ highlight: isHighlightIncomes }">
                                            <span class="label">
                                                <div class="inner">發票銷售總計<ah-tip>未稅</ah-tip></div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="revenue.unTaxedAmount" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item" :class="{ highlight: isHighlightIncomes }" v-if="revenue.tranInvoioceUnTaxAmount > 0">
                                            <span class="label">
                                                <div class="inner">核銷轉開發票<ah-tip>未稅</ah-tip></div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="revenue.tranInvoioceUnTaxAmount" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item" :class="{ highlight: isHighlightIncomes }">
                                            <span class="label">
                                                <div class="inner">核銷</div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="revenue.noneInvoiceUnTaxAmount" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item" :class="{ highlight: isHighlightIncomes }">
                                            <span class="label">
                                                <div class="inner">INVOICE</div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="revenue.invoiceUnTaxAmout" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="statis-detail compact">
                                    <ul class="value-list">
                                        <li class="item" :class="{ highlight: isHighlightIncomes }">
                                            <span class="label">
                                                <div class="inner">銷貨折讓退回<ah-tip>依發票開立日期統計</ah-tip></div>
                                            </span>
                                            <span class="value">
                                                <div
                                                    class="inner"
                                                    :class="{
                                                        'minus-item': revenue.returnAmount > 0,
                                                    }"
                                                >
                                                    <span v-if="revenue.returnAmount > 0">-</span>
                                                    <Money :v="revenue.returnAmount" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label">
                                                <div class="inner">銷項稅額總計</div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="revenue.taxAmount" round />
                                                    <!-- 不顯示：因為計算出來可能不足5%，容易誤解 -->
                                                    <span class="side-percentage"></span>
                                                </div>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12" :md="6">
                        <div class="ah-card shadow">
                            <div class="content">
                                <div :class="{ total: true }">
                                    <div class="statis-title main-color">
                                        <span>請款單支付</span>
                                        <ah-tip>
                                            <PaymentStatusLabel :statusNum="3" />＋ <PaymentStatusLabel :statusNum="2" />＋
                                            <PaymentStatusLabel :statusNum="5" />
                                            的請款單總額
                                        </ah-tip>
                                        <div class="sub-section-title">付款概況</div>
                                    </div>
                                    <div class="statis-num">
                                        <Money :v="payableInfo.accountsPayable + payableInfo.nonOperatingExpenses + payableInfo.assetsExpenses" round />
                                    </div>
                                </div>
                                <div class="statis-detail">
                                    <ul class="value-list">
                                        <li
                                            :class="{
                                                item: true,
                                                highlight: isHighlightPayouts,
                                            }"
                                        >
                                            <span class="label">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <PaymentStatusLabel :statusNum="3" />
                                                </div>
                                            </span>
                                            <span class="value">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <Money :v="payableInfo.accountPaid" round />
                                                    <span class="side-percentage"> {{ paymentCompletePercentage }}% </span>
                                                </div>
                                            </span>
                                        </li>
                                        <li
                                            :class="{
                                                item: true,
                                                highlight: isHighlightPayouts,
                                            }"
                                        >
                                            <span class="label">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <PaymentStatusLabel :status-num="2"></PaymentStatusLabel>
                                                </div>
                                            </span>
                                            <span class="value">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <Money :v="payableInfo.toBeCredited" round />
                                                    <span class="side-percentage"> {{ paymentConfirmPendingPercentage }}% </span>
                                                </div>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <PaymentStatusLabel :status-num="5"></PaymentStatusLabel>
                                                </div>
                                            </span>
                                            <span class="value">
                                                <div class="inner" style="margin-bottom: 4px;">
                                                    <Money :v="payableInfo.pendingPayment" round />
                                                    <span class="side-percentage"> {{ paymentPendingPercentage }}% </span>
                                                </div>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="statis-detail compact">
                                    <ul class="value-list">
                                        <li v-if="payableInfo.nonOperatingExpenses != 0" class="item" :class="{ highlight: isHighlightPayouts }">
                                            <span class="label">
                                                <div class="inner">轉列營業其他支出<ah-tip>支出項目為「營業其他支出」的請款單總額</ah-tip></div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="payableInfo.nonOperatingExpenses" round />
                                                </div>
                                            </span>
                                        </li>
                                        <li v-if="payableInfo.assetsExpenses != 0" class="item">
                                            <span class="label">
                                                <div class="inner">轉列財務資產支出<ah-tip>支出項目為「財務資產支出」的請款單總額</ah-tip></div>
                                            </span>
                                            <span class="value">
                                                <div class="inner">
                                                    <Money :v="payableInfo.assetsExpenses" round />
                                                </div>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12" :md="6">
                        <div class="ah-card shadow">
                            <div class="content">
                                <div
                                    :class="{
                                        total: true,
                                        highlight: isHighlightPayouts,
                                    }"
                                >
                                    <div class="statis-title main-color" style="display: flex; justify-content: space-between">
                                        <div>人事薪資<ah-tip>固定薪資 + 非固定薪資 + 績效＆獎金 + 人事費用</ah-tip></div>
                                        <div v-if="salaryInfo.months" style="padding-right: 5px">
                                            <span v-if="salaryInfo.months.length > 0">
                                                <span>（至{{ latestSalaryYear }}月）</span>
                                                <ah-tip>
                                                    <div style="line-height: 150%;">有登載薪資月份：</div>
                                                    <div style="line-height: 150%;">{{ salaryYears }}</div>
                                                </ah-tip>
                                            </span>
                                            <span v-else><ah-tip>本年度尚未登載人事薪資</ah-tip></span>
                                        </div>
                                    </div>
                                    <div class="statis-num">
                                        <span :class="{ item: true }">
                                            <Money :v="salaryInfo.amount" round />
                                        </span>
                                    </div>
                                </div>
                                <div class="statis-detail">
                                    <ul class="value-list">
                                        <li class="item">
                                            <span class="label"
                                                >固定薪資
                                                <ah-tip>含代扣</ah-tip>
                                            </span>
                                            <span class="value">
                                                <Money :v="salaryInfo.fixedSalary" round />
                                                <span class="side-percentage"> {{ fixedSalaryPercentage }}% </span>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label"
                                                >非固定薪資
                                                <ah-tip>含代扣</ah-tip>
                                            </span>
                                            <span class="value">
                                                <Money :v="salaryInfo.nonFixedSalary" round />
                                                <span class="side-percentage"> {{ nonFixedSalaryPercentage }}% </span>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label"
                                                >績效＆獎金
                                                <ah-tip>含代扣</ah-tip>
                                            </span>
                                            <span class="value">
                                                <Money :v="salaryInfo.bonus" round />
                                                <span class="side-percentage"> {{ bonusPercentage }}% </span>
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label"
                                                >人事費用
                                                <ah-tip>
                                                    <div>勞保、健保、二代健保、退休金</div>
                                                    <div style="font-size: 9pt; margin-top: 5px">(公司負擔)</div>
                                                </ah-tip>
                                            </span>
                                            <span class="value">
                                                <Money :v="salaryInfo.costs" round />
                                                <span class="side-percentage"> {{ costsPercentage }}% </span>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12" :md="6">
                        <div class="ah-card shadow financial-income">
                            <div class="content">
                                <div
                                    :class="{
                                        total: true,
                                        highlight: isHighlightIncomes,
                                    }"
                                >
                                    <div class="statis-title main-color">
                                        財務管理-營業其他收入
                                        <ah-tip>例如：利息收入...，非財務資產收入。</ah-tip>
                                    </div>
                                    <div class="statis-num">
                                        <span
                                            :class="{
                                                highlight: isHighlightIncomes,
                                            }"
                                        >
                                            <Money :v="variableInfo.income" round />
                                        </span>
                                    </div>
                                </div>
                                <div class="statis-detail">
                                    <ul class="value-list">
                                        <li class="item">
                                            <span class="label"> 進貨折讓退回收款 </span>
                                            <span class="value">
                                                <Money :v="variableInfo.feE_BACK_IN" round />
                                            </span>
                                        </li>
                                        <li class="item">
                                            <span class="label"> 其他 </span>
                                            <span class="value">
                                                <Money :v="variableInfo.income - variableInfo.feE_BACK_IN" round />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="ah-card shadow financial-payout">
                            <div class="content">
                                <div
                                    :class="{
                                        total: true,
                                        highlight: isHighlightPayouts,
                                    }"
                                >
                                    <div class="statis-title main-color">
                                        財務管理-營業其他支出
                                        <ah-tip>例如：利息支出、損失、罰款...，非財務資產支出。</ah-tip>
                                    </div>
                                    <div class="statis-num">
                                        <span
                                            :class="{
                                                highlight: isHighlightPayouts,
                                            }"
                                        >
                                            <Money :v="variableInfo.payout" round />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';
import YearOverviewChart from './Charts/YearOverviewChart.vue';

export default {
    name: 'overview-panel',
    components: {
        YearOverviewChart,
        PaymentStatusLabel,
        InvoiceStatusLabel,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: null,
        },
        monthlyRevenueDatas: {
            type: Object,
            default() {
                return {};
            },
        },
        revenueInfo: {
            type: Object,
            default() {
                return {
                    income: 0,
                    netIncome: 0,
                    payout: 0,
                };
            },
        },
        revenue: {
            type: Object,
            default() {
                return {
                    invoiceUnTaxAmout: 0,
                    noneInvoiceUnTaxAmount: 0,
                    returnAmount: 0,
                    taxAmount: 0,
                    tranInvoioceUnTaxAmount: 0,
                    unTaxedAmount: 0,
                };
            },
        },
        receivableInfo: {
            type: Object,
            default() {
                return {
                    accountsReceived: 0,
                    accountsReceivable: 0,
                    accruedReceivables: 0,
                };
            },
        },
        payableInfo: {
            type: Object,
            default() {
                return {
                    accountsPayable: 0,
                    accountPaid: 0,
                    accruedPayable: 0,
                    pendingPayment: 0,
                    toBeCredited: 0,
                };
            },
        },
        salaryInfo: {
            type: Object,
            default() {
                return {
                    amount: 0,
                    fixedSalary: 0,
                    nonFixedSalary: 0,
                    bonus: 0,
                    costs: 0,
                };
            },
        },
        variableInfo: {
            type: Object,
            default() {
                return {
                    income: 0,
                    payout: 0,
                };
            },
        },
    },
    data() {
        return {
            isHighlightIncomes: false,
            isHighlightPayouts: false,
            mode: 0,
        };
    },
    computed: {
        currentDate() {
            return moment().format('YYYY-MM-DD');
        },
        isShowRealTime() {
            return this.year === new Date().getFullYear();
        },
        profitPercentage() {
            if (this.revenueInfo.income <= 0) return '--';

            const p = Math.round((this.revenueInfo.netIncome / this.revenueInfo.income) * 100);
            return p || '--';
        },
        invoiceTax() {
            return this.receivableInfo.accountsReceived - this.receivableInfo.accountsReceivedNoTax;
        },
        payoutPercentage() {
            if (this.revenueInfo.income <= 0) return '--';

            const p = Math.abs(this.getPercentage(this.revenueInfo.payout / this.revenueInfo.income));
            return p || '--';
        },
        invoiceCompletePercentage() {
            return this.getPercentage(this.receivableInfo.accountsReceivable / this.receivableInfo.accountsReceived);
        },
        invoicePendingPercentage() {
            return this.getPercentage(this.receivableInfo.accruedReceivables / this.receivableInfo.accountsReceived);
        },
        paymentCompletePercentage() {
            return this.getPercentage(this.payableInfo.accountPaid / this.payableInfo.accountsPayable);
        },
        paymentConfirmPendingPercentage() {
            return this.getPercentage(this.payableInfo.toBeCredited / this.payableInfo.accountsPayable);
        },
        paymentPendingPercentage() {
            return this.getPercentage(this.payableInfo.pendingPayment / this.payableInfo.accountsPayable);
        },

        fixedSalaryPercentage() {
            return this.getPercentage(this.salaryInfo.fixedSalary / this.salaryInfo.amount);
        },
        nonFixedSalaryPercentage() {
            return this.getPercentage(this.salaryInfo.nonFixedSalary / this.salaryInfo.amount);
        },
        bonusPercentage() {
            return this.getPercentage(this.salaryInfo.bonus / this.salaryInfo.amount);
        },
        costsPercentage() {
            return this.getPercentage(this.salaryInfo.costs / this.salaryInfo.amount);
        },

        creditNoteNoTaxTotal() {
            return _.sum(this.monthlyRevenueDatas.creditNoteNoTax);
        },

        totalRevenue() {
            return this.revenue.unTaxedAmount + this.revenue.noneInvoiceUnTaxAmount + this.revenue.tranInvoioceUnTaxAmount + this.revenue.invoiceUnTaxAmout - this.revenue.returnAmount;
        },
        latestSalaryYear() {
            return _.max(this.salaryInfo.months);
        },
        salaryYears() {
            return _.chain(this.salaryInfo.months)
                .sort((a, b) => a - b)
                .map((m) => `${m}月`)
                .join('、')
                .value();
        },
    },
    methods: {
        getPercentage(ratio) {
            if (Number.isNaN(ratio) || !Number.isFinite(ratio)) return '--';
            return Math.round(ratio * 100);
        },
    },
};
</script>
<style lang="scss">
.overview-panel {
    position: relative;
    padding-bottom: 0px;

    .overiew-radio-group.el-radio-group {
        > .el-radio-button {
            > .el-radio-button__inner {
                background-color: #ffffffaa;
                border-color: transparent;
                font-weight: bold;
                color: #463cb2;
            }

            &.is-active {
                > .el-radio-button__inner {
                    background-color: #fff;
                    color: #463cb2;
                    border-color: #fff;
                    box-shadow: none;
                }
            }
        }
    }

    .realtime-label {
        position: absolute;
        right: -23px;
        background-color: #ffba00;
        font-size: 10pt;
        font-weight: bold;
        color: #000000cc;
        padding: 3px 15px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

        &:after {
            position: absolute;
            right: 0;
            bottom: -8px;
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 8px 8px 0 0;
            border-color: #996916 transparent transparent transparent;
        }
    }

    .ah-card {
        @media (max-width: 720px) {
            display: block;
            margin-bottom: 20px;
        }
        .content {
            .total {
                padding: 0px;
                border-radius: 10px;

                &.highlight {
                    background-color: #fff3ba;
                }
            }
        }
    }

    .statis-detail {
        .item {
            .label > .inner {
                vertical-align: top;
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
                padding: 0 0 0 0;
                line-height: 26px;

                .ah-tip {
                    line-height: 0px;
                }
            }

            .value > .inner {
                line-height: 26px;
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }

            &.highlight {
                .label > .inner {
                    background-color: #fff3ba;
                }

                .value > .inner {
                    background-color: #fff3ba;
                }
            }
        }
    }
    .side-percentage {
        display: inline-block;
        color: #aaa;
        margin-left: 5px;
        min-width: 35px;

        @media (max-width: 1200px) {
            margin-left: 5px;
            min-width: 25px;
            font-size: 8pt;
        }
    }

    .income-payout-status {
        .el-row {
            display: flex;
            flex-wrap: wrap;

            .el-col {
                margin-bottom: 20px;
            }
        }
        .ah-card {
            height: 100%;
            margin-bottom: 0;

            @media (max-width: 720px) {
                margin-bottom: 10px;
            }

            &.financial-income {
                height: 235px;
                margin-bottom: 15px;
            }
            &.financial-payout {
                height: 150px;
            }
            &.invoice-status {
                height: 400px;
                // margin-bottom: 15px;
            }
            &.invoice-summary {
                height: 350px;
            }
        }
    }
    .sub-section-title {
        display: inline-block;
        background-color: #f1f1f5;
        margin-left: 8px;
        font-size: 10pt;
        font-weight: bold;
        border-radius: 4px;
        padding: 0px 10px;
        color: #515878;
    }
    .minus-item {
        color: red;
    }

    @media (max-width: 1200px) {
        .four-statistics {
            .ah-tip {
                position: relative;
                .tip-icon {
                    position: absolute;
                    top: 1px;
                    width: 11px;
                }
            }
        }
    }
}
</style>
